module.exports = __webpack_public_path__ + "static/media/misPagos_orange.cb6fc524.svg";